import * as React from 'react';
import { Modal as ModalComponent } from 'decentraland-ui/dist/components/Modal/Modal';
export default class Modal extends React.PureComponent {
    handleClose = () => {
        const { name, onCloseModal } = this.props;
        onCloseModal(name);
    };
    render() {
        // Omit `onCloseModal` from the props we pass down to ModalComponent
        const { name, onCloseModal, ...modalProps } = this.props;
        return (React.createElement(ModalComponent, { open: true, className: name, size: "small", onClose: this.handleClose, ...modalProps }));
    }
}
//# sourceMappingURL=Modal.js.map